export default __webpack_public_path__ + "c3faee1555a5ab1888847813b2a161af.png";